import React, { ChangeEvent } from 'react';
import { RangePickerFooter, StyledRangePicker } from './styles';
import { IRangePickerProps } from './types';
import NativeRange from '../nativeRange';
import FloatInput from '../floatInput/FloatInput';
import { TypeInputRef } from '../input/types';
import { Text4 } from '../globalStyles';
import {stringToMoney, stringToNumber} from '../utils';

const MoneyRangePicker: React.FC<IRangePickerProps> = React.forwardRef((props, ref: TypeInputRef) => {
	const { min, max, step, minMaxText, placeholder, defaultValue, value, onChange, ...rest } = props;

	const [stateInputValue, setInputValue] = React.useState<string>(stringToNumber(String(defaultValue)));
	const [stateInputValueFormatted, setInputValueFormatted] = React.useState<string>(stringToNumber(String(defaultValue)));

	React.useEffect(() => {
		if (typeof value === 'undefined') return;
		setInputValue(stringToNumber(String(value)));
		setInputValueFormatted(stringToMoney(String(value), 0));
	}, [value]);

	const onInputChange = React.useCallback(
		(ev: ChangeEvent<HTMLInputElement>) => {
			setInputValue(ev.target.value);
			setInputValueFormatted(ev.target.value);
			if (onChange) onChange(ev);
		},
		[setInputValue, onChange]
	);

	const onRangeChange = React.useCallback(
		(ev: ChangeEvent<HTMLInputElement>) => {
			setInputValue(ev.target.value);
			setInputValueFormatted(stringToMoney(ev.target.value, 0));
			if (onChange) onChange(ev);
		},
		[setInputValue, onChange]
	);

	return (
		<StyledRangePicker style={{marginBottom: '40px'}}>
			<FloatInput {...rest} ref={ref} placeholder={placeholder} value={stateInputValueFormatted} onChange={onInputChange} digitsAfterDot={0} />
			<NativeRange {...rest} ref={ref} min={min} max={max} step={step} value={stateInputValue} onChange={onRangeChange} />
			<RangePickerFooter>
				<Text4>
					{stringToMoney(min, 0)} {minMaxText}
				</Text4>
				<Text4>
					{stringToMoney(max, 0)} {minMaxText}
				</Text4>
			</RangePickerFooter>
		</StyledRangePicker>
	);
});

export default React.memo(MoneyRangePicker);
